"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
// permissions.js
var PERMISSIONS_LIST = exports.PERMISSIONS_LIST = ["IMMEDIATE_CUSTOMER", "EMPLOYEE"];


//////////////////
// WEBPACK FOOTER
// ./app/utils/mappings/permissions.js
// module id = 1428
// module chunks = 0